import { RouteRecordRaw, createRouter, createWebHistory } from "vue-router";
import HomeView from "@/views/Home.vue";

const routes: Array<RouteRecordRaw> = [
  {
    path: "/",
    name: "Home",
    component: HomeView,
    beforeEnter: (to, from, next) => {
      const q = to.query || { redirect: "" };
      const p = q.redirect;
      const isValid = "/about" === p || "/projects" === p;

      if (isValid) {
        next(() => p);
        return;
      }

      next();
    }
  },
  {
    path: "/projects",
    name: "Projects",
    // route level code-splitting
    // this generates a separate chunk (projects.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "projects" */ "@/views/Projects.vue")
  },
  {
    path: "/about",
    name: "About",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ "@/views/About.vue")
  },
  // and finally the default route, when none of the above matches:
  {
    path: "/:catchAll(.*)",
    name: "PageNotFound",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "status404" */ "@/views/PageNotFound.vue")
  }
];

export default createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
});
